<script lang="ts">
  export let id: string;
</script>

<!-- Modal -->
<modal id="{id}">
  <!-- Modal content-->
  <div>
    <div class="modal-header">
        <h3 class="modal-title">
          <slot name="title"/>
        </h3>
    </div>
    <div class="modal-body">
      <slot/>
    </div>
    <div class="modal-footer">
      <slot name="footer"/>
    </div>
  </div>
</modal>

<style>
</style>
